var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrmImg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2475 1650",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2,.cls-34,.cls-5{fill:#fff;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:#bdd0fb;}.cls-5{opacity:0.62;}.cls-6{fill:#dce5fe;}.cls-7{fill:#18174a;}.cls-8{fill:#2b69b3;}.cls-9{fill:#91b3fa;}.cls-10{opacity:0.74;}.cls-11{opacity:0.65;}.cls-12{fill:url(#linear-gradient-2);}.cls-13{opacity:0.78;}.cls-14{fill:url(#linear-gradient-3);}.cls-15{fill:url(#linear-gradient-4);}.cls-16{fill:url(#linear-gradient-5);}.cls-17{fill:url(#linear-gradient-6);}.cls-18{fill:url(#linear-gradient-7);}.cls-19{fill:url(#linear-gradient-8);}.cls-20{fill:url(#linear-gradient-9);}.cls-21{fill:url(#linear-gradient-10);}.cls-22{fill:url(#linear-gradient-11);}.cls-23{fill:url(#linear-gradient-12);}.cls-24{fill:url(#linear-gradient-13);}.cls-25{fill:url(#linear-gradient-14);}.cls-26{fill:url(#linear-gradient-15);}.cls-27{fill:url(#linear-gradient-16);}.cls-28{fill:#f0f0f0;}.cls-29{fill:url(#linear-gradient-17);}.cls-30{fill:url(#linear-gradient-18);}.cls-31{clip-path:url(#clip-path);}.cls-32{fill:url(#linear-gradient-19);}.cls-33{fill:url(#linear-gradient-20);}.cls-34{opacity:0.67;}.cls-35{fill:url(#linear-gradient-21);}.cls-36{fill:url(#linear-gradient-22);}.cls-37{fill:url(#linear-gradient-23);}.cls-38{fill:url(#linear-gradient-24);}.cls-39{fill:url(#linear-gradient-25);}.cls-40{fill:url(#linear-gradient-26);}.cls-41{fill:url(#linear-gradient-27);}.cls-42{fill:url(#linear-gradient-28);}.cls-43{fill:url(#linear-gradient-29);}.cls-44{fill:url(#linear-gradient-30);}.cls-45{fill:url(#linear-gradient-31);}.cls-46{fill:url(#linear-gradient-32);}.cls-47{fill:url(#linear-gradient-33);}.cls-48{fill:url(#linear-gradient-34);}.cls-49{fill:url(#linear-gradient-35);}.cls-50{fill:url(#linear-gradient-36);}.cls-51{fill:url(#linear-gradient-37);}.cls-52{fill:url(#linear-gradient-38);}.cls-53{fill:url(#linear-gradient-39);}.cls-54{fill:url(#linear-gradient-40);}.cls-55{fill:url(#linear-gradient-41);}.cls-56{fill:url(#linear-gradient-42);}.cls-57{fill:url(#linear-gradient-43);}.cls-58{fill:url(#linear-gradient-44);}.cls-59{fill:url(#linear-gradient-45);}.cls-60{fill:url(#linear-gradient-46);}.cls-61{fill:url(#linear-gradient-47);}.cls-62{fill:url(#linear-gradient-48);}.cls-63{fill:url(#linear-gradient-49);}.cls-64{fill:url(#linear-gradient-50);}.cls-65{fill:url(#linear-gradient-51);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 114.93,
    y1: 778.52,
    x2: 2359.82,
    y2: 778.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 445.06,
    y1: 826.2,
    x2: 366.2,
    y2: 654.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -3800.46,
    y1: 969.23,
    x2: -3768.19,
    y2: 1050.16,
    gradientTransform: "matrix(-1, 0, 0, 1, -3075.51, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#020039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#090056"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -3869.65,
    y1: 1015.97,
    x2: -3809.94,
    y2: 1151.83,
    gradientTransform: "matrix(-1, 0, 0, 1, -3075.51, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -3680.57,
    y1: 1486.28,
    x2: -3652.46,
    y2: 1486.28,
    gradientTransform: "matrix(-1, 0, 0, 1, -3075.51, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4042e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -3798.84,
    y1: 1593.93,
    x2: -3759.58,
    y2: 1135.05,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -3811.13,
    y1: 1481.3,
    x2: -3765.66,
    y2: 1481.3,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -3717.46,
    y1: 1600.49,
    x2: -3678.23,
    y2: 1142.03,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -3798.36,
    y1: 1131.16,
    x2: -3778.72,
    y2: 1313.36,
    gradientTransform: "matrix(-1, 0, 0, 1, -3075.51, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 727.52,
    y1: 1049.21,
    x2: 703.2,
    y2: 1132.41,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -3772.44,
    y1: 1167.9,
    x2: -3721.97,
    y2: 1167.9,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -3822.49,
    y1: 1072.41,
    x2: -3757.66,
    y2: 957.03,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -3808.29,
    y1: 972.13,
    x2: -3775.97,
    y2: 1053.19,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -3808.26,
    y1: 1080.07,
    x2: -3743.46,
    y2: 964.74,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -3882.75,
    y1: 1021.69,
    x2: -3823,
    y2: 1157.62,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 849.78,
    y1: 800.16,
    x2: 835.21,
    y2: 916.68,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1187.23,
    y1: 451.2,
    x2: 1219.39,
    y2: 1215.18,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1186.29,
    y1: 283.85,
    x2: 1217.4,
    y2: 1022.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1513.56 580.59 1517.14 580.59 1517.14 181.04 883.6 181.04 883.6 580.59 884.14 580.59 882.36 581.89 1040.61 677.49 1198.85 773.03 1357.1 677.47 1515.34 581.88 1513.56 580.59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1731.47,
    y1: 663.43,
    x2: 1971.8,
    y2: 384.47,
    gradientTransform: "translate(2054.93 -1632.27) rotate(81.38)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 2107.61,
    y1: 181.01,
    x2: 1396.93,
    y2: 1254.63,
    gradientTransform: "translate(846.83 -1286.75) rotate(45)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 2086.41,
    y1: 211.77,
    x2: 1707.99,
    y2: 847.07,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 2000.65,
    y1: 861.4,
    x2: 2169.54,
    y2: 665.37,
    gradientTransform: "translate(2490.73 -1587.63) rotate(81.11)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 2264.97,
    y1: 522.39,
    x2: 1765.55,
    y2: 1276.87,
    gradientTransform: "translate(1104.13 -1342.78) rotate(45)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 2250.07,
    y1: 544.01,
    x2: 1984.14,
    y2: 990.46,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1791.27,
    y1: 944.08,
    x2: 1935.67,
    y2: 776.47,
    gradientTransform: "translate(2500.15 -1237) rotate(83.87)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 2017.27,
    y1: 654.22,
    x2: 1590.26,
    y2: 1299.31,
    gradientTransform: "translate(1114.45 -1144.36) rotate(45)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 2004.53,
    y1: 672.7,
    x2: 1777.16,
    y2: 1054.42,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1519.04,
    y1: 1300.5,
    x2: 1625.1,
    y2: 1300.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 1725.3,
    y1: 1303.74,
    x2: 1848.17,
    y2: 1303.74,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1590.75,
    y1: 1170.21,
    x2: 1763.42,
    y2: 1170.21,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1593.88,
    y1: 1170.21,
    x2: 1760.29,
    y2: 1170.21,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 1590.75,
    y1: 1260.16,
    x2: 1763.42,
    y2: 1260.16,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 1576.17,
    y1: 1260.16,
    x2: 1782.94,
    y2: 1260.16,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 1590.75,
    y1: 1350.1,
    x2: 1763.42,
    y2: 1350.1,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 1557.57,
    y1: 1350.1,
    x2: 1802.7,
    y2: 1350.1,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 1590.75,
    y1: 1440.05,
    x2: 1821.44,
    y2: 1440.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 1542.53,
    y1: 1440.05,
    x2: 1821.44,
    y2: 1440.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -2742.76,
    y1: 1245.95,
    x2: -2707.49,
    y2: 1245.95,
    gradientTransform: "matrix(-1, 0, 0, 1, -996.59, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -2739.19,
    y1: 1229.56,
    x2: -2724.88,
    y2: 1229.56,
    gradientTransform: "matrix(-1, 0, 0, 1, -996.59, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -2667.76,
    y1: 1245.38,
    x2: -2612.42,
    y2: 1245.38,
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -2666.92,
    y1: 1223.2,
    x2: -2652.69,
    y2: 1223.2,
    gradientTransform: "matrix(-1, 0, 0, 1, -996.59, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 1709.72,
    y1: 1027.57,
    x2: 1730.1,
    y2: 1027.57,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -2491.6,
    y1: 772.87,
    x2: -2520.54,
    y2: 932.9,
    gradientTransform: "matrix(-1, 0.07, 0.07, 1, -961.14, 102.47)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -2475.05,
    y1: 877.4,
    x2: -2422.18,
    y2: 877.4,
    gradientTransform: "matrix(-1, 0.07, 0.07, 1, -961.14, 102.47)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -2632.36,
    y1: 905.9,
    x2: -2661.3,
    y2: 1179.97,
    gradientTransform: "matrix(-1, 0, 0, 1, -996.59, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 1288.76,
    y1: 1069.9,
    x2: 1393.76,
    y2: 997.9,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 1270.62,
    y1: 1043.46,
    x2: 1375.62,
    y2: 971.46,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -2580.55,
    y1: 732.32,
    x2: -2691.18,
    y2: 935.6,
    gradientTransform: "matrix(-1, 0, 0, 1, -996.59, 0)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -2458.35,
    y1: 1622.3,
    x2: -2507.25,
    y2: 1686.99,
    gradientTransform: "matrix(-0.82, -0.58, -0.58, 0.82, 545.93, -1973.39)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 1621.3,
    y1: 711.12,
    x2: 1626.76,
    y2: 913.07,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -2529.96,
    y1: 1673.53,
    x2: -2490.75,
    y2: 1633.29,
    gradientTransform: "matrix(-0.82, -0.58, -0.58, 0.82, 545.93, -1973.39)",
    xlinkHref: "#linear-gradient-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 2475,
    height: 1650
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1981.57,522c-100.54-54.45,26.19-184-17.34-280.09-8.11-17.9-23.91-40.5-78.7-67.67C1646.31,55.57,1276.08,114,1276.08,114c-313.82,49.48-355.28,126.13-493,76.51-76.89-27.7-138.63-78.5-260-83.66-38.93-1.65-110.6-4.7-181,28.57-195.74,92.5-284.7,420-187.59,592,30.69,54.35,67.76,62.7,74.88,120.75,7.24,59-39.07,118.38-92,277.8-83.44,251.32,242.81,429.2,526.16,272.75s244.29-172.65,619.78-9.11,647.39-32.73,884.38-210C2639.92,826.44,2108.93,591,1981.57,522Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M945.54,1495.27s92.17-103.42,77.19-201.19S933,1208,899.67,1265.79s-63.2,49.88-43.43-4.47,44.56-89.74,3.58-143.84-45.22-77.1-22.19-125.38S889.56,875.41,798,851,615.1,901.59,636.46,999.74s34.19,108.84,4.77,145.19-17.16,51.29-13,75-40.78,29.21-39.83-4.12,58.14-112,19.11-148.7S492,1030,472.42,1114.82s43.17,123,40.05,153.69-36.84-15.84-66.2,15.44,10.17,55.87,39.26,72.82,73,47.35,31.22,69.42-81.26.94-55.69,69.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M756.06,921.78a48.76,48.76,0,0,0-8.22,5.13,61.34,61.34,0,0,0-7.12,6.32,71.54,71.54,0,0,0-11.24,15A86.33,86.33,0,0,0,719,983.07c-.19,1.51-.25,3-.33,4.53s-.17,3-.13,4.53l0,4.53.25,4.52.13,2.26.25,2.24.51,4.5c.5,3,.85,6,1.49,8.91s1.21,5.9,2,8.81l1.12,4.38,1.17,4.23,4.71,16.9c6.23,22.52,12.24,45,17,67.66s7.76,45.47,7.05,68.06a144.52,144.52,0,0,1-1.4,16.8,113.77,113.77,0,0,1-3.45,16.4,98.08,98.08,0,0,1-6,15.63,109.74,109.74,0,0,0-6.54,17.43,253.11,253.11,0,0,0-6.44,35.16c-1.37,11.69-2.44,23.34-3.29,35-1.79,23.23-3.32,46.4-7.08,69.25-.47,2.85-1,5.7-1.57,8.53s-1.22,5.66-1.87,8.48-1.48,5.59-2.2,8.4c-.41,1.39-.88,2.76-1.31,4.15s-.86,2.77-1.41,4.12l-1.54,4.07c-.52,1.36-1.18,2.67-1.76,4-1.11,2.69-2.58,5.23-3.92,7.85a71.55,71.55,0,0,1-10.79,14.21l1.05.92a75.76,75.76,0,0,0,12.32-13.84,103.54,103.54,0,0,0,8.68-15.93c4.91-11,8.14-22.45,10.79-34,5.3-23,7.81-46.36,10.67-69.48,1.45-11.56,2.74-23.1,4.51-34.52a244.65,244.65,0,0,1,7.26-33.56,106.79,106.79,0,0,1,6.21-15.55,109.86,109.86,0,0,0,7-17.28,125.67,125.67,0,0,0,4.13-17.83,154.35,154.35,0,0,0,1.86-18c1.12-24-2.21-47.64-6.7-70.82a687.31,687.31,0,0,0-17.71-68.52c-1.75-5.62-3.51-11.25-5.33-16.85l-1.37-4.2-1.25-4.09c-.89-2.72-1.56-5.47-2.29-8.22s-1.26-5.51-1.91-8.28l-.72-4.17c-.26-1.39-.48-2.78-.64-4.17a118.08,118.08,0,0,1-1.14-16.78,86,86,0,0,1,1.57-16.7,82.83,82.83,0,0,1,4.83-16.21,78.91,78.91,0,0,1,3.86-7.69,63.59,63.59,0,0,1,4.77-7.31,59.33,59.33,0,0,1,12.69-12.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M952.27,1272.1a494.54,494.54,0,0,1-11.43,54.35q-3.6,13.42-8,26.64c-.69,2.22-1.52,4.39-2.27,6.59s-1.56,4.37-2.38,6.54c-1.55,4.38-3.31,8.68-5,13s-3.63,8.58-5.65,12.79c-1.86,4.26-4,8.42-6.06,12.61-4.34,8.29-8.92,16.47-14,24.41a265.35,265.35,0,0,1-16.64,23.06,259.78,259.78,0,0,1-19.72,21.2l1,1a172.11,172.11,0,0,0,22.49-19.51,215,215,0,0,0,18.61-22.65,246.16,246.16,0,0,0,15-24.66c2.17-4.26,4.4-8.49,6.36-12.83s3.81-8.71,5.65-13.08,3.46-8.82,5-13.28c.81-2.22,1.55-4.46,2.25-6.7s1.48-4.48,2.12-6.74c2.78-9,5.07-18.09,7.05-27.23,3.88-18.3,6.59-36.79,7-55.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1068.25 1173.39 1032.63 1492.85 1445.88 1492.85 1392.06 1173.39 1068.25 1173.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M374.06,386.32V1118a111,111,0,0,0,108.13,111c267.23,6.89,1201.86,23.6,1456.25,19.85a81.67,81.67,0,0,0,80.4-79.34c4.91-170,12.87-578.69-16.61-768.44a84,84,0,0,0-80.36-71.14C1698,322.69,707.19,299.94,452.93,305.66A80.66,80.66,0,0,0,374.06,386.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M420,382.76v695.11a64.3,64.3,0,0,0,63.34,64.3l1418.53,17.52a62.58,62.58,0,0,0,63.52-62.34l2.37-688.9a45.75,45.75,0,0,0-44.65-45.92L470.76,333.19A49.58,49.58,0,0,0,420,382.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1976,1188.39h0L419.93,1161.88a2.18,2.18,0,0,1,0-4.36h0L1976.08,1184a2.18,2.18,0,0,1,0,4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1534.9,1558.21H930.07c-16.43,0-28.77-11.7-25.59-24.26l7.76-30.69c2.34-9.23,12.49-16,24.55-16.39l583.07-18.19c12.61-.4,23.76,6.29,26.51,15.89l14,48.88C1564,1546.15,1551.6,1558.21,1534.9,1558.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1255.66,1495.39a2.18,2.18,0,0,1,0-4.35l25-.37a2.18,2.18,0,0,1,.06,4.36l-25,.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M926.87,1541.5a2,2,0,0,1-.34,0,2.18,2.18,0,0,1-1.81-2.49l3.56-22.33a25.12,25.12,0,0,1,24.47-21.18l265-3.88a2.22,2.22,0,0,1,2.21,2.15,2.18,2.18,0,0,1-2.14,2.21l-265,3.87a20.76,20.76,0,0,0-20.23,17.52L929,1539.66A2.19,2.19,0,0,1,926.87,1541.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M920.55,626.16a32.13,32.13,0,1,0-22.24-10.49A31.87,31.87,0,0,0,920.55,626.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1097.6,578.94l-7.9-39.07a2.72,2.72,0,0,0-2.31-2.16l-32.92-4.4a144.9,144.9,0,0,0-26.19-38.91l8.35-32.17a2.74,2.74,0,0,0-1.13-3l-33.21-22a2.74,2.74,0,0,0-3.17.1l-26.4,20.19a144.72,144.72,0,0,0-46-9l-16.83-28.63a2.7,2.7,0,0,0-2.89-1.29l-39.08,7.89a2.72,2.72,0,0,0-2.16,2.32l-4.4,32.91a144.9,144.9,0,0,0-38.91,26.19l-32.16-8.35a2.73,2.73,0,0,0-3,1.13l-22,33.22a2.72,2.72,0,0,0,.11,3.16l20.18,26.41a144.66,144.66,0,0,0-9,46L747.88,606.3a2.74,2.74,0,0,0-1.29,2.9l7.89,39.07a2.72,2.72,0,0,0,2.32,2.16l32.92,4.4a144.67,144.67,0,0,0,26.19,38.91l-8.35,32.16a2.71,2.71,0,0,0,1.13,3l33.21,22a2.74,2.74,0,0,0,3.17-.1l26.4-20.19a144.72,144.72,0,0,0,46,9l16.83,28.63a2.74,2.74,0,0,0,2.9,1.29l39.07-7.89a2.74,2.74,0,0,0,2.17-2.32l4.39-32.92a144.87,144.87,0,0,0,38.91-26.18l32.17,8.35a2.75,2.75,0,0,0,3-1.14l22-33.21a2.72,2.72,0,0,0-.1-3.17l-20.18-26.4a144.93,144.93,0,0,0,9-46l28.63-16.83A2.73,2.73,0,0,0,1097.6,578.94Zm-92.12,69.47a99.48,99.48,0,0,1-116,38.77l2.19-6.15a92.94,92.94,0,1,0-60.11-69.22c.37,1.85.81,3.7,1.29,5.52a96,96,0,0,0,3.11,9.6,1.8,1.8,0,0,1,.08.21l.5,1.26c.31.76.63,1.53,1,2.28l-6,2.61a99.56,99.56,0,0,1,43.16-127,99.46,99.46,0,0,1,130.83,142.14Zm-122-56.19a38.68,38.68,0,1,1,10,27.85A38.68,38.68,0,0,1,883.47,592.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M652.42,802.72a19.54,19.54,0,1,0-10.71-10.44A19.38,19.38,0,0,0,652.42,802.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M777,785,757,775a97.35,97.35,0,0,0-8.11-30.45L761.28,726a1.85,1.85,0,0,0-.07-2.13L745,702.55a1.82,1.82,0,0,0-2-.63l-21.18,7a97.26,97.26,0,0,0-27.25-15.81l-4.42-21.87a1.82,1.82,0,0,0-1.55-1.45L662,666.27a1.83,1.83,0,0,0-1.88,1l-10,19.94a97.34,97.34,0,0,0-30.45,8.1L601.05,683a1.82,1.82,0,0,0-2.13.07L577.65,699.3a1.82,1.82,0,0,0-.63,2l7,21.19a97.34,97.34,0,0,0-15.81,27.24l-21.87,4.42a1.84,1.84,0,0,0-1.45,1.56l-3.55,26.53a1.85,1.85,0,0,0,1,1.89l19.94,10a97.09,97.09,0,0,0,8.11,30.44l-12.35,18.6a1.83,1.83,0,0,0,.07,2.12L574.4,866.6a1.82,1.82,0,0,0,2,.62l21.19-7A97,97,0,0,0,624.87,876l4.41,21.87a1.85,1.85,0,0,0,1.56,1.46l26.54,3.54a1.85,1.85,0,0,0,1.88-1l10-20a97.28,97.28,0,0,0,30.44-8.1l18.6,12.35a1.85,1.85,0,0,0,2.13-.07l21.27-16.26a1.86,1.86,0,0,0,.63-2l-7-21.18a97.43,97.43,0,0,0,15.82-27.25L773,815a1.84,1.84,0,0,0,1.46-1.55L778,786.87A1.81,1.81,0,0,0,777,785Zm-48.6,8.39a68.86,68.86,0,0,1-111.09,44.76l5.27-6.61a60.39,60.39,0,1,0-22.26-55.26,61.33,61.33,0,0,0-.4,12.18c0,.22,0,.45.05.68l-8.42.66a69,69,0,0,1,.39-14.64c.05-.39.11-.77.17-1.16a69,69,0,0,1,56.35-57.56,66.41,66.41,0,0,1,6.94-.84h0a68.82,68.82,0,0,1,73,77.8Zm-94.71-19.2a27.86,27.86,0,0,1,15-15.34,28.18,28.18,0,0,1,6.31-1.88,28,28,0,1,1-21.27,17.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1695.43,637.65l-5.53-27.38a1.91,1.91,0,0,0-1.63-1.51l-23.06-3.08a101.31,101.31,0,0,0-18.35-27.26l5.85-22.54a1.92,1.92,0,0,0-.79-2.08l-23.27-15.44a1.92,1.92,0,0,0-2.22.07l-18.5,14.14a101.28,101.28,0,0,0-32.24-6.32l-11.8-20.06a1.91,1.91,0,0,0-2-.91l-27.38,5.53a1.94,1.94,0,0,0-1.52,1.63l-3.07,23.06a101.52,101.52,0,0,0-27.27,18.35L1480.1,568a1.92,1.92,0,0,0-2.08.79l-15.44,23.27a1.92,1.92,0,0,0,.07,2.22l14.14,18.5a101.28,101.28,0,0,0-6.32,32.24l-20.06,11.8a1.91,1.91,0,0,0-.91,2l5.53,27.38a1.94,1.94,0,0,0,1.63,1.52l23.06,3.07a101.52,101.52,0,0,0,18.35,27.27l-5.85,22.53a1.92,1.92,0,0,0,.79,2.08l23.27,15.44a1.92,1.92,0,0,0,2.22-.07l18.5-14.14a101.28,101.28,0,0,0,32.24,6.32L1581,770.3a1.92,1.92,0,0,0,2,.91l27.38-5.53a1.9,1.9,0,0,0,1.51-1.63L1615,741a101.31,101.31,0,0,0,27.26-18.35l22.54,5.85a1.92,1.92,0,0,0,2.08-.79l15.44-23.27a1.92,1.92,0,0,0-.07-2.22l-14.14-18.5a101.28,101.28,0,0,0,6.32-32.24l20.06-11.79A1.93,1.93,0,0,0,1695.43,637.65Zm-62.78,49.84a71.81,71.81,0,0,1-83.75,28l2.94-8.31a62.86,62.86,0,1,0-37-34.77c.09.21.18.43.28.65l-8.09,3.52a72.59,72.59,0,0,1-4.59-14.57c-.08-.4-.15-.8-.23-1.2a72,72,0,0,1,36-75.93c2.11-1.16,4.3-2.23,6.55-3.19h0a71.8,71.8,0,0,1,87.85,105.82Zm-89.36-40.64a29,29,0,0,1,9.53-20.22,29.62,29.62,0,0,1,5.59-4,29.22,29.22,0,1,1-15.12,24.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1571.49,668.61a20.37,20.37,0,1,0-14.12-6.65A20.25,20.25,0,0,0,1571.49,668.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1241,891.73c6.16,3.35,13.09,4.53,20.06,4.53h0c15.4,0,29.54-7.79,36.9-21.3a41,41,0,0,0,3.41-31.65,41.42,41.42,0,0,0-20.18-24.86,42.12,42.12,0,0,0-57,16.88,41.34,41.34,0,0,0,16.77,56.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1482.72,882.74l-35.43-23.4a185.14,185.14,0,0,0-8.44-59.36l27.53-32.36a3.47,3.47,0,0,0,.35-4l-25.92-43.88a3.5,3.5,0,0,0-3.71-1.64l-41.62,8.5a185.28,185.28,0,0,0-47.92-36l-3.41-42.32a3.48,3.48,0,0,0-2.61-3.1l-49.35-12.69a3.48,3.48,0,0,0-3.78,1.46L1265,669.3a185.14,185.14,0,0,0-59.36,8.44l-32.35-27.53a3.48,3.48,0,0,0-4-.35l-43.88,25.92a3.5,3.5,0,0,0-1.64,3.71l8.51,41.62a185.05,185.05,0,0,0-36,47.92l-42.32,3.41a3.49,3.49,0,0,0-3.1,2.61l-12.7,49.35a3.5,3.5,0,0,0,1.46,3.78L1075,851.59a184.87,184.87,0,0,0,8.45,59.36l-27.54,32.35a3.52,3.52,0,0,0-.35,4l25.93,43.88a3.48,3.48,0,0,0,3.7,1.64l41.62-8.5a185.07,185.07,0,0,0,47.93,36l3.4,42.33a3.5,3.5,0,0,0,2.61,3.1l49.36,12.69a3.48,3.48,0,0,0,3.78-1.46l23.4-35.42a185.14,185.14,0,0,0,59.36-8.44l32.36,27.53a3.48,3.48,0,0,0,4,.35l43.87-25.92a3.5,3.5,0,0,0,1.64-3.71l-8.5-41.62a185.28,185.28,0,0,0,36-47.92l42.32-3.41a3.5,3.5,0,0,0,3.1-2.61l12.69-49.35A3.5,3.5,0,0,0,1482.72,882.74Zm-264.19-50.5a48.51,48.51,0,0,1,89.14,9.52,46.85,46.85,0,0,1-3.94,36.37c-8.51,15.61-24.85,24.75-42.64,24.75h0c-8.06,0-16.07-1.49-23.18-5.37a47.86,47.86,0,0,1-19.38-65.27Zm165.32,55.34h0a3.1,3.1,0,0,1,.41.26s.43.07.43.08v.13s-.45,0-.46.06l-.23,0s-.12-.36-.12-.34-.06-.38-.06-.38h0s0,.44,0,.46v.22c0,.09,0,.27-.07.35l0,.2v.05l-.12.47v0c0,.1-.51.2-.53.29s-.49.08-.49.11h.46s.88,0,.88,0,.87.05.87.07h0c-13.24,54.82-66.13,90.41-123,90.41h0c-10.58,0-21.18,0-31.52-2.2h0c-55.82-13.25-94.81-64.22-94.81-121.78a126.34,126.34,0,0,1,37.48-89.58,3.3,3.3,0,0,1,4.59,4.73,119.65,119.65,0,0,0-31.74,55.31,116.24,116.24,0,0,0-3.8,29.39,118.7,118.7,0,0,0,89.91,115.3h0s.83.54.85.55c9.79,2.51,19.6,4.49,30.64,4.49v-.14c55.19,0,101.07-36.73,114.88-89.33,0,0-.37-.09-.36-.12s-.19-.06-.18-.09l-.1.4s-.07.36-.07.36h0l.3-.49s.31-.63.31-.65v.07h-.29s.13,0,.14,0,.15-.06.15-.09h0a136.51,136.51,0,0,0,3.53-29.91,119.75,119.75,0,0,0-90-115.83,121,121,0,0,0-25.17-3.71,3.24,3.24,0,0,1-3.1-3.26v-.13c2.21-1.8,1.47-3.19,3.29-3.14a125.77,125.77,0,0,1,117.28,157.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M438.42,891.88H319.79a41.19,41.19,0,0,0-35.67,20.6l-59.31,102.73a41.18,41.18,0,0,0,0,41.19l59.31,102.73a41.19,41.19,0,0,0,35.67,20.6H438.42a41.18,41.18,0,0,0,35.67-20.6l59.32-102.73a41.23,41.23,0,0,0,0-41.19L474.09,912.48A41.18,41.18,0,0,0,438.42,891.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M319.79,1160a21.54,21.54,0,0,1-18.6-10.73l-59.31-102.74a21.56,21.56,0,0,1,0-21.48l59.31-102.73a21.55,21.55,0,0,1,18.6-10.74H438.42A21.55,21.55,0,0,1,457,922.33l59.31,102.74a21.5,21.5,0,0,1,0,21.47L457,1149.27a21.53,21.53,0,0,1-18.6,10.74Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M379.12,1038.19c-21.94,0-38.34-23-38.34-43.56,0-20.74,16.48-36.38,38.34-36.38s38.35,15.64,38.35,36.38C417.47,1015.19,401.07,1038.19,379.12,1038.19Zm0-73.41c-18.13,0-31.81,12.83-31.81,29.85s13.9,37,31.81,37,31.81-19.9,31.81-37S397.26,964.78,379.12,964.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M421.22,1112.78H335.59a24,24,0,0,1-23.16-17.72L308.88,1082a23.87,23.87,0,0,1,15.35-29c20.28-6.75,40-10.17,58.72-10.17a148.72,148.72,0,0,1,51.24,9,23.89,23.89,0,0,1,14.5,29.83l-4.61,14.4A23.92,23.92,0,0,1,421.22,1112.78ZM383,1049.37c-18,0-37,3.31-56.66,9.84a17.34,17.34,0,0,0-11.1,21.06l3.55,13.08a17.5,17.5,0,0,0,16.85,12.89h85.63a17.4,17.4,0,0,0,16.63-12.14l4.61-14.4a17.37,17.37,0,0,0-10.52-21.7A142.1,142.1,0,0,0,383,1049.37Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M440.33,198.94H321.71A41.19,41.19,0,0,0,286,219.54L226.72,322.27a41.18,41.18,0,0,0,0,41.19L286,466.2a41.21,41.21,0,0,0,35.68,20.59H440.33A41.21,41.21,0,0,0,476,466.2l59.31-102.74a41.18,41.18,0,0,0,0-41.19L476,219.54A41.19,41.19,0,0,0,440.33,198.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M321.71,467.08a21.54,21.54,0,0,1-18.6-10.74L243.79,353.61a21.56,21.56,0,0,1,0-21.48L303.11,229.4a21.52,21.52,0,0,1,18.6-10.74H440.33a21.52,21.52,0,0,1,18.6,10.74l59.31,102.73a21.51,21.51,0,0,1,0,21.48L458.93,456.34a21.54,21.54,0,0,1-18.6,10.74Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M414.4,418.05h0a5.59,5.59,0,0,1-2.5-.55c-3.5-1.45-5.12-3.86-5.12-6.62V395.17H318.87c-9.71,0-18.05-11.35-18.05-21.06V298.9c0-10.57,9.08-16.32,19.08-16.32H442c10.19,0,17.76,6.13,17.76,16.32v75.21a17.32,17.32,0,0,1-15.4,17.31L420.29,415.9A8.7,8.7,0,0,1,414.4,418.05ZM319.9,289.21c-4.95,0-10.25,4.47-10.25,9.69v75.21c0,4.78,4.44,10,9.22,10h91.48c2.41,0,5.26,2.82,5.26,5.22v19.4L439,384.15a5.47,5.47,0,0,1,3.59-1.33,8.41,8.41,0,0,0,8.35-8.71V298.9c0-5.37-3.56-9.69-8.93-9.69Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 318.48,
    y: 309.07,
    width: 117,
    height: 6.62,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 318.48,
    y: 328.94,
    width: 117,
    height: 6.62,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 318.48,
    y: 353.22,
    width: 117,
    height: 6.62,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M440.33,543H321.71A41.19,41.19,0,0,0,286,563.58L226.72,666.31a41.18,41.18,0,0,0,0,41.19L286,810.23a41.19,41.19,0,0,0,35.68,20.6H440.33A41.19,41.19,0,0,0,476,810.23L535.32,707.5a41.18,41.18,0,0,0,0-41.19L476,563.58A41.19,41.19,0,0,0,440.33,543Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M321.71,811.11a21.53,21.53,0,0,1-18.6-10.73L243.79,697.64a21.54,21.54,0,0,1,0-21.47l59.32-102.74a21.53,21.53,0,0,1,18.6-10.73H440.33a21.53,21.53,0,0,1,18.6,10.73l59.31,102.74a21.5,21.5,0,0,1,0,21.47L458.93,800.38a21.53,21.53,0,0,1-18.6,10.73Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M381.58,758.25c-1.23,0-2.45,0-3.68-.08-42-1.86-74.85-35.33-73.13-74.62.83-19.11,9.6-36.7,24.67-49.53a78.68,78.68,0,0,1,54.7-18.38c42,1.85,74.85,35.33,73.13,74.62h0c-.84,19.11-9.6,36.7-24.68,49.53A78.29,78.29,0,0,1,381.58,758.25Zm-1.12-132.63a68.35,68.35,0,0,0-44.5,16c-12.92,11-20.43,26-21.14,42.32-1.48,33.75,27,62.52,63.52,64.13a68.62,68.62,0,0,0,47.73-16c12.93-11,20.44-26,21.15-42.31,1.48-33.75-27-62.52-63.53-64.13C382.61,625.64,381.54,625.62,380.46,625.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M399.23,687.22a200.63,200.63,0,0,1-2.87,34.95c-.52,2.88-1.12,5.74-1.84,8.58a82.18,82.18,0,0,1-2.57,8.4,39.35,39.35,0,0,1-3.83,7.92,15.68,15.68,0,0,1-2.88,3.37,8.43,8.43,0,0,1-1.88,1.22,5.77,5.77,0,0,1-2.2.52,5.61,5.61,0,0,1-2.22-.41,7.57,7.57,0,0,1-1.93-1.16,14.71,14.71,0,0,1-2.94-3.31,38.83,38.83,0,0,1-3.89-7.89,80.42,80.42,0,0,1-2.59-8.39c-.73-2.84-1.34-5.71-1.86-8.58-1.05-5.76-1.76-11.58-2.24-17.41s-.72-11.68-.75-17.53c0-2.93.07-5.85.17-8.77s.27-5.85.48-8.76c.44-5.84,1.08-11.66,2-17.43.48-2.88,1-5.76,1.71-8.6a82.16,82.16,0,0,1,2.43-8.44c.49-1.38,1-2.74,1.64-4.08a30.75,30.75,0,0,1,2.09-3.87,14.06,14.06,0,0,1,2.87-3.33,7.53,7.53,0,0,1,1.9-1.15,5.28,5.28,0,0,1,2.19-.39,5.74,5.74,0,0,1,2.16.51,8.37,8.37,0,0,1,1.88,1.18,16.05,16.05,0,0,1,2.93,3.28,38.87,38.87,0,0,1,4,7.79,79,79,0,0,1,2.76,8.34c.78,2.82,1.44,5.67,2,8.54A184.1,184.1,0,0,1,399.23,687.22Zm-.86,0q0-8.73-.69-17.46a171.32,171.32,0,0,0-2.27-17.32c-.54-2.86-1.16-5.71-1.91-8.52a77.2,77.2,0,0,0-2.65-8.31,39,39,0,0,0-3.9-7.77,16,16,0,0,0-2.84-3.24,8.14,8.14,0,0,0-1.8-1.16,5.47,5.47,0,0,0-2.06-.5,5.05,5.05,0,0,0-2.07.39,7,7,0,0,0-1.82,1.12,14.37,14.37,0,0,0-2.77,3.29,30,30,0,0,0-2,3.85c-.59,1.32-1.11,2.68-1.58,4.06a83.65,83.65,0,0,0-2.32,8.41c-.64,2.84-1.17,5.7-1.62,8.58-.89,5.76-1.47,11.57-1.83,17.38s-.5,11.65-.49,17.48.18,11.65.61,17.46,1.1,11.61,2.1,17.35c.5,2.87,1.08,5.72,1.78,8.55a80.05,80.05,0,0,0,2.51,8.34A38.28,38.28,0,0,0,374.5,747a14.46,14.46,0,0,0,2.81,3.22,7.31,7.31,0,0,0,1.8,1.1,5.11,5.11,0,0,0,2,.39,5.05,5.05,0,0,0,2-.5,7.35,7.35,0,0,0,1.76-1.16,15.55,15.55,0,0,0,2.76-3.28,39.09,39.09,0,0,0,3.71-7.84,83.41,83.41,0,0,0,2.49-8.35c.69-2.83,1.26-5.68,1.76-8.55,1-5.74,1.65-11.54,2.08-17.35S398.37,693.05,398.37,687.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M381,753.88a7.32,7.32,0,0,1-2.69-.53A9.3,9.3,0,0,1,376,752a16.55,16.55,0,0,1-3.29-3.69A39.85,39.85,0,0,1,368.6,740a83.48,83.48,0,0,1-2.66-8.57c-.7-2.74-1.31-5.58-1.88-8.7-1-5.52-1.74-11.27-2.26-17.57-.47-5.72-.73-11.67-.76-17.66,0-3.13.08-6.23.17-8.84.12-3,.28-5.94.49-8.83.47-6.33,1.14-12.08,2.05-17.58.52-3.13,1.09-6,1.74-8.72a85.39,85.39,0,0,1,2.48-8.61c.56-1.56,1.11-2.94,1.69-4.22a32.84,32.84,0,0,1,2.21-4.09,16.25,16.25,0,0,1,3.23-3.73,9.06,9.06,0,0,1,2.35-1.4,7.11,7.11,0,0,1,2.87-.51,7.36,7.36,0,0,1,2.78.65,9.9,9.9,0,0,1,2.26,1.41,17.54,17.54,0,0,1,3.26,3.63,39.79,39.79,0,0,1,4.21,8.14,80,80,0,0,1,2.83,8.51c.75,2.74,1.42,5.58,2,8.67a184.45,184.45,0,0,1,3.24,35.23h0a201.2,201.2,0,0,1-2.9,35.23c-.56,3.12-1.17,6-1.86,8.71a85.56,85.56,0,0,1-2.63,8.58,41.1,41.1,0,0,1-4,8.26,17.39,17.39,0,0,1-3.2,3.73,9.67,9.67,0,0,1-2.28,1.47,7.32,7.32,0,0,1-2.87.67Zm-.88-129.24a3.28,3.28,0,0,0-1.29.27,5.49,5.49,0,0,0-1.38.85,12.51,12.51,0,0,0-2.42,2.9,28.16,28.16,0,0,0-1.9,3.62c-.53,1.18-1,2.46-1.52,3.92a79.65,79.65,0,0,0-2.28,8.23c-.6,2.67-1.12,5.44-1.59,8.48-.83,5.39-1.43,11-1.82,17.22-.33,5.3-.49,11-.48,17.36,0,5.9.19,11.73.6,17.35.47,6.16,1.14,11.78,2.08,17.18.53,3,1.1,5.77,1.76,8.42a77.45,77.45,0,0,0,2.46,8.17,35.89,35.89,0,0,0,3.59,7.46,12.56,12.56,0,0,0,2.46,2.84,5.57,5.57,0,0,0,1.37.84,3.72,3.72,0,0,0,1.34.27,3.68,3.68,0,0,0,1.36-.34,6.26,6.26,0,0,0,1.37-.91,13.66,13.66,0,0,0,2.44-2.92,37.65,37.65,0,0,0,3.54-7.49,79.45,79.45,0,0,0,2.43-8.18c.64-2.64,1.21-5.4,1.74-8.43.92-5.35,1.59-11,2.06-17.19.43-5.6.64-11.43.64-17.34h0c0-5.88-.22-11.7-.69-17.32a166.3,166.3,0,0,0-2.24-17.15c-.56-3-1.17-5.73-1.88-8.4a79.11,79.11,0,0,0-2.59-8.13,37,37,0,0,0-3.73-7.42,14.05,14.05,0,0,0-2.52-2.89,6,6,0,0,0-1.42-.92,3.56,3.56,0,0,0-1.39-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M428.62,687.22a85.85,85.85,0,0,1-3,22.33A72.27,72.27,0,0,1,416.3,730a59,59,0,0,1-7.11,8.73,49.18,49.18,0,0,1-8.75,7.07,42.28,42.28,0,0,1-10.2,4.69,38.05,38.05,0,0,1-22.2,0,42,42,0,0,1-10.22-4.68,50,50,0,0,1-8.76-7.06,59.22,59.22,0,0,1-7.12-8.74,72.32,72.32,0,0,1-9.33-20.48,82,82,0,0,1-2.26-11.07,90.55,90.55,0,0,1-.76-11.28,88.66,88.66,0,0,1,.77-11.27,80.49,80.49,0,0,1,2.27-11.07A72.23,72.23,0,0,1,342,644.42a59.14,59.14,0,0,1,7.12-8.73,50,50,0,0,1,8.76-7.05A42.25,42.25,0,0,1,368.06,624a37.7,37.7,0,0,1,22.16,0,41.84,41.84,0,0,1,10.2,4.67,50.25,50.25,0,0,1,8.75,7.05,59.53,59.53,0,0,1,7.1,8.73,71.9,71.9,0,0,1,9.32,20.46A85.85,85.85,0,0,1,428.62,687.22Zm-1,0a84.45,84.45,0,0,0-2.89-22.08,71.85,71.85,0,0,0-9-20.34,58.25,58.25,0,0,0-7-8.71,48.54,48.54,0,0,0-8.59-7.07,41.81,41.81,0,0,0-10.08-4.68,37,37,0,0,0-21.94,0A41.78,41.78,0,0,0,358.1,629a48.1,48.1,0,0,0-8.58,7.08,57.62,57.62,0,0,0-6.93,8.71,71.62,71.62,0,0,0-9,20.33,83,83,0,0,0-2.16,10.94,85.72,85.72,0,0,0,0,22.25,81.41,81.41,0,0,0,2.17,10.94,71.5,71.5,0,0,0,9,20.31,58.83,58.83,0,0,0,6.94,8.71,48.86,48.86,0,0,0,8.58,7.06A41.47,41.47,0,0,0,368.19,750a36.63,36.63,0,0,0,21.9,0,41.89,41.89,0,0,0,10.07-4.66,48.13,48.13,0,0,0,8.59-7.06,57.67,57.67,0,0,0,6.95-8.7,71.76,71.76,0,0,0,9-20.32A84.49,84.49,0,0,0,427.63,687.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M379.14,753.88a40.22,40.22,0,0,1-11.59-1.72,43.64,43.64,0,0,1-10.63-4.87,51.25,51.25,0,0,1-9.06-7.3,61.45,61.45,0,0,1-7.33-9A73.58,73.58,0,0,1,331,710a83.32,83.32,0,0,1-2.31-11.31,88.93,88.93,0,0,1-.77-11.49,90.64,90.64,0,0,1,.78-11.5A83.32,83.32,0,0,1,331,664.42a73.65,73.65,0,0,1,9.57-20.95,60.6,60.6,0,0,1,7.33-9,51.61,51.61,0,0,1,9.06-7.3,44.3,44.3,0,0,1,10.62-4.84,39.45,39.45,0,0,1,23.14,0,43.71,43.71,0,0,1,10.61,4.85,51.55,51.55,0,0,1,9.05,7.3,60.49,60.49,0,0,1,7.31,9,73.29,73.29,0,0,1,9.54,21,87.09,87.09,0,0,1,3.1,22.77v0A87.53,87.53,0,0,1,427.24,710a73.67,73.67,0,0,1-9.53,21,60.58,60.58,0,0,1-7.31,9,52.07,52.07,0,0,1-9,7.31,44,44,0,0,1-10.62,4.87A39.79,39.79,0,0,1,379.14,753.88Zm0-129.5a36.37,36.37,0,0,0-10.46,1.6,40,40,0,0,0-9.66,4.5,46.4,46.4,0,0,0-8.27,6.83,56.09,56.09,0,0,0-6.73,8.46,69.58,69.58,0,0,0-8.77,19.84,79.92,79.92,0,0,0-2.11,10.71,85.43,85.43,0,0,0-.72,10.91,89.21,89.21,0,0,0,.72,10.9,81.84,81.84,0,0,0,2.12,10.71A69.94,69.94,0,0,0,344,728.67a57.06,57.06,0,0,0,6.73,8.44,46.31,46.31,0,0,0,8.28,6.82,39.87,39.87,0,0,0,9.64,4.48,34.89,34.89,0,0,0,20.92,0,40,40,0,0,0,9.66-4.47,47,47,0,0,0,8.28-6.81,57.2,57.2,0,0,0,6.74-8.45,69.93,69.93,0,0,0,8.81-19.84,83.93,83.93,0,0,0,0-43.26,70,70,0,0,0-8.79-19.85,57.29,57.29,0,0,0-6.74-8.46,47.32,47.32,0,0,0-8.29-6.82,40,40,0,0,0-9.66-4.48A36.12,36.12,0,0,0,379.13,624.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M321.4,661.52l14.86-.12,14.86-.07,29.72-.05,29.72.06,14.86.07,14.85.13a0,0,0,0,1,.05.05s0,0-.05,0l-14.85.13-14.86.08-29.72.06-29.72-.06-14.86-.07-14.86-.12a.1.1,0,0,1-.06,0C321.34,661.55,321.37,661.52,321.4,661.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "380.84 663.6 336.25 663.48 320.68 663.35 319.64 662.31 319.64 661.55 319.68 659.88 321.39 659.82 351.11 659.63 380.84 659.57 425.42 659.71 441.97 659.86 442.02 663.29 440.27 663.34 410.56 663.54 380.84 663.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M338.64,636.54c3.52-.06,7-.08,10.55-.12l10.55-.07c3.52,0,7,0,10.55,0l10.55,0,21.1.07,10.55.07c3.51,0,7,.07,10.55.13l0,0s0,.07,0,.07c-3.52.06-7,.08-10.55.13l-10.55.07-21.1.06-10.55,0c-3.52,0-7,0-10.55,0l-10.55-.07-10.55-.12s-.06,0-.06-.07A.06.06,0,0,1,338.64,636.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M380.84,638.62l-13.29,0q-3.92,0-7.82,0l-14.07-.1-7.05-.09-1.67,0-.06-3.45,1.73-.07,6.82-.08,14.3-.1q3.7,0,7.43,0l13.68,0,35.5.18,6.73.08,1.72,0-.07,3.43-1.68,0c-2.32,0-4.67.07-7,.09l-14.07.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M316.24,686.51l16.15-.12,16.15-.07,32.3-.06,32.3.06,16.15.08,16.15.13a0,0,0,0,1,0,0,.14.14,0,0,1,0,0l-16.15.13-16.15.07-32.3.06-32.3,0-16.15-.07-16.15-.12a.07.07,0,0,1-.07-.07A.07.07,0,0,1,316.24,686.51Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "380.84 688.59 332.38 688.46 314.54 688.33 314.48 684.87 316.23 684.8 348.53 684.61 380.84 684.56 429.3 684.69 446.16 684.83 447.19 685.88 447.12 688.28 445.44 688.32 413.15 688.52 380.84 688.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M321.4,711.49l14.86-.12,14.86-.07,29.72,0,29.72.06,14.86.07,14.85.13a.08.08,0,0,1,.05,0c0,.05,0,.07-.05.07l-14.85.13-14.86.07-29.72.06-29.72-.05-14.86-.07-14.86-.12a.07.07,0,0,1-.06-.07A.06.06,0,0,1,321.4,711.49Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "380.84 713.57 336.25 713.45 320.68 713.32 319.64 712.28 319.64 711.52 319.68 709.85 321.39 709.79 351.11 709.6 380.84 709.54 425.42 709.68 441.97 709.82 442.02 713.26 440.27 713.3 410.56 713.51 380.84 713.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M425.16,736.77H340.77a.23.23,0,1,1,0-.46h84.39a.23.23,0,0,1,0,.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M425.16,738.47H340.77a1.93,1.93,0,1,1,0-3.86h84.39a1.93,1.93,0,0,1,0,3.86Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M706.56,1013.06s-11.17,5.28-13.23,11.34c-1.65,4.86-14,5.49-15.22,15a11.11,11.11,0,0,1-9.46,9.64c-12.62,1.88-32.06,8.24-35.17,29.51-2.38,16.23,6.15,22.38,15.09,24.51,6.57,1.57,10.94,7.77,9.61,14.21-1.28,6.18.63,13.32,11.65,19,24.7,12.65,49.37-30,49.37-30l5-74.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M822.84,973.81s-31.79,84.11-86,110.4c0,0,18,28.54,27.44,30.28,0,0,57.85-71.88,63.75-130.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M605,1479.74l-1.6,12.76a5.37,5.37,0,0,1-4.76,4.61,87.11,87.11,0,0,1-17.59.26,4.51,4.51,0,0,1-3.9-5.85c1.61-4.92,4.56-12.31,8.81-16.66h14.58A4.41,4.41,0,0,1,605,1479.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M719.2,1330.32l2.46,14s-8.24,81-9.71,113.41a24.83,24.83,0,0,0,3.88,14.44l14.32,22.58-36.41-20.86-.72-4.31,6-8-7.81-90.75a27.16,27.16,0,0,1,3.26-15.4l7.54-13.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M732.55,1498.07H720.93a7.07,7.07,0,0,1-5.55-2.64c-3.62-4.57-11.13-13.49-14.72-13.72-4.83-.31-4.21,16.36-4.21,16.36h-2.71l-3.43-20.72a12.16,12.16,0,0,1,6.63-12.81h0s1.1,7.92,7.09,11.43S728.4,1492,728.4,1492a17,17,0,0,1,4.72.13A3,3,0,0,1,732.55,1498.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M669.33,1337s-48.27,88.88-55.94,109.17S603,1483.38,602.92,1485c-.16,2.51-3.37,4.91-12.21,4.91-4.57,0-6.81-1.78-7.9-3.5a4.87,4.87,0,0,1-.2-4.84c2.8-5.49,11.66-23,14.94-31,3.92-9.49,12.34-52.51,17-67.46s9.84-31.18,30-46.13C644.49,1337,658.31,1323.86,669.33,1337Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M699.82,1191.37c12.45-51.22-19.09-80.18-19.09-80.18,19.9-18.55,56.16-27,56.16-27s34.6,24.55,30.5,43.77c-2.41,11.27-24.32,67.48-24.32,67.48S722.8,1204.77,699.82,1191.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M672.21,1216.72c5.07-14.82,27.61-25.35,27.61-25.35,23,13.4,43.25,4.09,43.25,4.09s4.54,16.86,1.41,32.53-22.82,116.38-22.82,116.38c-31,6.1-78.7-6.14-78.7-6.14C662.71,1304.19,667.15,1231.54,672.21,1216.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M714.27,1050.36l-10.12,44.14c-1,3.89,2.68,3.25,6.73,2.51,6.63-1.21,15.18-3.71,18-8.72a4.64,4.64,0,0,0,.51-1.66l4.35-30.61a5.47,5.47,0,0,0-3.31-5.78l-8.4-3.61A5.7,5.7,0,0,0,714.27,1050.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M680.73,1111.19s-70.66,49.07-9,100.62a16,16,0,0,0,7,3.92c2.34.68,9.24,5.75,12.74,8.39a2.45,2.45,0,0,0,3.51-.61h0a3.1,3.1,0,0,0,.18-3l-8.75-18a6.9,6.9,0,0,0-8.76-.37h0a3.38,3.38,0,0,1-5.05-1.11c-4.76-9.41-13.75-37.11,23.06-68.4a3.8,3.8,0,0,0,.88-4.71C693.89,1123.1,688,1113.52,680.73,1111.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M726.15,1008.34s12,4.91,20.14,21.73,2.06,24.58-5.58,25.65-19.08.9-31.18-10S710.56,1002.51,726.15,1008.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M717.66,1036.78s-9-24.61,13.43-24.9l5.29,3.59s8.24-13.64-5.29-20.15-29.37-1.13-35.13,16.56-6.75,29.55,2.84,38,13.53-1.14,13.53-1.14-5.22-7.92-3.1-12.15,7,.87,7,.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M715.14,1039.52s-4.57-12.68-10.67-7.63,4.95,11.71,9.28,13.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M825.89,989.12c.48,1.5-5.13,3.78-8.44-2.34-.12-2.94-2-15.5-.15-17.89,9.62-12.73,28.26-28.68,28.26-28.68a4.21,4.21,0,0,1,.56,6l-9,9.15c1.9,3.31,4.2,6.12,5.29,10.13a12,12,0,0,1-1.27,9,107.35,107.35,0,0,1-5.8,9.21A12.64,12.64,0,0,1,825.89,989.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M830.71,982.91l-2.14-.38c.25-1.39,2.56-13.68,4.45-16.66a3.52,3.52,0,0,0,.78-2.54,1.46,1.46,0,0,0-.58-.76l-7.42,6.11-2.49,6.49-2-.73,2.69-7,9-7.41.64.32a4,4,0,0,1,2.29,2.43c.35,1.19,0,2.57-1,4.21C833.45,969.21,831.39,979.23,830.71,982.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1875,1504c62.5,11.81,142.32-52.59,168-122.93,26.46-72.4-22.06-102.72-21.69-203.18.43-114.11,63.25-131.31,104.8-285.13,9.38-34.7,63.63-235.53-3.61-273.18-62.17-34.8-236.81,65.08-267.41,192.93-21.83,91.17,45.64,129.44,19.87,235.62-22.61,93.16-82,94.51-104.8,184.4C1742.46,1341.9,1792.9,1488.44,1875,1504Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1879.51,1531.59c-16.85-122.95,16-312.63,46.56-450.1,33.07-148.84,70.6-270.24,71-271.45l5.2,1.44c-.37,1.21-37.85,122.45-70.87,271.1-30.45,137.07-63.24,326.13-46.48,448.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1918.56,1506.08c-58.92-29-79.09-128.63-45.6-161,22.63-21.87,55.09,1.14,86.4-21.54,40-29,10.57-83.48,42-154.2,26.74-60.19,90.9-117.14,128.39-105.45,39.24,12.23,59.91,103,26.39,157.6-21.79,35.52-55.15,37.27-62.39,70.3-8.4,38.34,32.18,55.82,32.4,93C2126.54,1451.51,1996.51,1544.46,1918.56,1506.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1950.36,1531.59a2.6,2.6,0,0,1-1-.22,2.22,2.22,0,0,1-1.11-3c78.11-152.11,101-328.56,101.24-330.32a2.38,2.38,0,0,1,2.67-2,2.31,2.31,0,0,1,2.1,2.52c-.23,1.78-23.23,179-101.69,331.77A2.43,2.43,0,0,1,1950.36,1531.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M2110.62,1243.71a1.16,1.16,0,0,1-.7-.22,1.05,1.05,0,0,1-.2-1.53c24.65-29.9,52-74.83,42.14-119-5.86-26.33-22.35-40.07-22.51-40.2a1,1,0,0,1-.12-1.53,1.2,1.2,0,0,1,1.62-.11c.7.57,17.24,14.35,23.26,41.4,5.53,24.85,2.63,66-42.58,120.83A1.19,1.19,0,0,1,2110.62,1243.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1913.25,1492.8a1.18,1.18,0,0,1-1-.47c-37.89-52.26-50.81-92.64-38.4-120,11-24.34,38.88-28.87,39.16-28.92a1.15,1.15,0,0,1,1.32.9,1.09,1.09,0,0,1-1,1.24c-.27,0-26.92,4.41-37.44,27.66-12.06,26.65.8,66.32,38.2,117.9a1,1,0,0,1-.29,1.51A1.2,1.2,0,0,1,1913.25,1492.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M883.67,582V903c0,23.62,20.75,42.77,46.34,42.77h539c25.6,0,46.34-19.15,46.34-42.77V582Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1357.1,486.41l-137-82.89a40.29,40.29,0,0,0-42.48,0l-137,82.87L882.36,582.11l158.25,95.49,158.24,95.48,158.25-95.59,158.24-95.38Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1416.67,220.87H927.61c-7.79,0-13.11,7.58-13.11,15.36v593.9H1484V288Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1416.67,220.87l1.13,61.74c0,1.58.07,3.1,1.19,4.21a5.33,5.33,0,0,0,4,1.73L1484,288Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 949.82,
    y: 331.15,
    width: 132.45,
    height: 11.04,
    rx: 5.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 949.82,
    y: 357.64,
    width: 132.45,
    height: 11.04,
    rx: 5.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 949.82,
    y: 379.71,
    width: 132.45,
    height: 11.04,
    rx: 5.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1009.42,
    y: 439.31,
    width: 439.29,
    height: 15.45,
    rx: 7.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 958.65,
    y: 487.88,
    width: 492.27,
    height: 15.45,
    rx: 7.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 958.65,
    y: 538.65,
    width: 492.27,
    height: 15.45,
    rx: 7.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 958.65,
    y: 589.42,
    width: 492.27,
    height: 15.45,
    rx: 7.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 958.65,
    y: 640.19,
    width: 492.27,
    height: 15.45,
    rx: 7.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 958.65,
    y: 690.97,
    width: 492.27,
    height: 15.45,
    rx: 7.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 958.65,
    y: 741.74,
    width: 492.27,
    height: 15.45,
    rx: 7.3
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 1976.66,
    cy: 378.84,
    r: 179.18,
    transform: "translate(1305.82 2276.38) rotate(-81.38)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1976.66,
    cy: 378.84,
    r: 173.22,
    transform: "translate(311.07 1508.67) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1833.82,308.79a1.91,1.91,0,0,1-1.7-2.77,162.06,162.06,0,0,1,173.73-86.36,1.9,1.9,0,1,1-.69,3.74,159.42,159.42,0,0,0-28.5-2.56,157.35,157.35,0,0,0-141.14,86.9A1.9,1.9,0,0,1,1833.82,308.79Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 1980.43,
    cy: 382.61,
    r: 146.61,
    transform: "translate(309.51 1512.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1966,491.6v-16c-16.62-.66-33.07-4.59-44.75-9.7a9.23,9.23,0,0,1-5.1-10.9l4-14.86a9.3,9.3,0,0,1,12.63-6.08,108.08,108.08,0,0,0,41.32,8.7c16,0,28-5.43,28-16.56,0-10.05-9.23-16-31.49-22-31.76-8.69-54.56-22.53-54.56-50.49,0-25.24,18.46-44.52,50.49-49.67v-16a9.29,9.29,0,0,1,9.29-9.29h9.37a9.29,9.29,0,0,1,9.3,9.29v14.33c15.38.61,26.58,3.24,35.47,6.37A9.24,9.24,0,0,1,2035.8,320l-3.73,13.74a9.26,9.26,0,0,1-12.23,6.26,96.83,96.83,0,0,0-34.79-6.32c-19,0-24.43,7.87-24.43,14.93,0,8.69,11.4,14.66,36.1,22.26,35.29,10.59,50,25.25,50,51.58,0,24.16-17.92,45.87-52.66,51.3V491.6a9.31,9.31,0,0,1-9.3,9.3h-9.37A9.31,9.31,0,0,1,1966,491.6Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 2172.95,
    cy: 661.41,
    r: 125.92,
    transform: "matrix(0.15, -0.99, 0.99, 0.15, 1183.79, 2706.1)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-37",
    cx: 2172.95,
    cy: 661.41,
    r: 121.73,
    transform: "translate(168.76 1730.23) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M2072.57,612.18a1.29,1.29,0,0,1-.6-.14,1.34,1.34,0,0,1-.59-1.8,113.86,113.86,0,0,1,122.08-60.69,1.34,1.34,0,1,1-.48,2.63,112.53,112.53,0,0,0-20-1.8,110.57,110.57,0,0,0-99.18,61.07A1.36,1.36,0,0,1,2072.57,612.18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 2175.6,
    cy: 664.06,
    r: 103.03,
    transform: "translate(167.66 1732.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M2165.49,740.65v-11.2a91.56,91.56,0,0,1-31.45-6.82,6.48,6.48,0,0,1-3.58-7.66l2.84-10.44a6.54,6.54,0,0,1,8.88-4.28,75.91,75.91,0,0,0,29,6.11c11.26,0,19.65-3.81,19.65-11.63,0-7.06-6.48-11.26-22.13-15.45-22.31-6.11-38.34-15.84-38.34-35.49,0-17.74,13-31.28,35.48-34.9V597.68a6.54,6.54,0,0,1,6.53-6.54H2179a6.53,6.53,0,0,1,6.53,6.54v10.06a83.12,83.12,0,0,1,24.93,4.48,6.49,6.49,0,0,1,4.06,7.84l-2.62,9.66a6.52,6.52,0,0,1-8.6,4.4,67.87,67.87,0,0,0-24.45-4.44c-13.35,0-17.16,5.53-17.16,10.49,0,6.1,8,10.3,25.37,15.64,24.8,7.44,35.1,17.74,35.1,36.25,0,17-12.59,32.23-37,36.05v12.54a6.53,6.53,0,0,1-6.53,6.54H2172A6.53,6.53,0,0,1,2165.49,740.65Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 1938.59,
    cy: 773.08,
    r: 107.66,
    transform: "translate(962.83 2617.99) rotate(-83.87)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-40",
    cx: 1938.59,
    cy: 773.08,
    r: 104.08,
    transform: "translate(21.15 1597.22) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1852.76,731a1.19,1.19,0,0,1-.51-.12,1.15,1.15,0,0,1-.51-1.54,96.83,96.83,0,0,1,86.85-53.47,97.88,97.88,0,0,1,17.54,1.58,1.14,1.14,0,0,1-.41,2.25,96.07,96.07,0,0,0-17.13-1.54,94.54,94.54,0,0,0-84.8,52.21A1.15,1.15,0,0,1,1852.76,731Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 1940.86,
    cy: 775.35,
    r: 88.09,
    transform: "translate(1161.08 2714.44) rotate(-89.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1932.21,840.84v-9.58a78,78,0,0,1-26.89-5.84,5.52,5.52,0,0,1-3.06-6.54l2.43-8.93a5.59,5.59,0,0,1,7.59-3.66,64.81,64.81,0,0,0,24.82,5.23c9.63,0,16.8-3.26,16.8-9.95,0-6-5.54-9.62-18.92-13.21-19.08-5.22-32.78-13.54-32.78-30.34,0-15.17,11.09-26.75,30.34-29.84v-9.59a5.58,5.58,0,0,1,5.58-5.58h5.63a5.58,5.58,0,0,1,5.59,5.58v8.61a71.49,71.49,0,0,1,21.31,3.82,5.56,5.56,0,0,1,3.47,6.71l-2.24,8.26a5.56,5.56,0,0,1-7.35,3.76,58.08,58.08,0,0,0-20.9-3.8c-11.42,0-14.68,4.73-14.68,9,0,5.22,6.85,8.81,21.69,13.38,21.2,6.36,30,15.17,30,31,0,14.51-10.76,27.56-31.64,30.82v10.73a5.58,5.58,0,0,1-5.58,5.58h-5.63A5.58,5.58,0,0,1,1932.21,840.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M391.57,649l-.53,6.48v0a1.12,1.12,0,1,1-2.24-.19h0l.6-6.53a1.09,1.09,0,1,1,2.17.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M390.46,670.65l0,6.5v0a1.24,1.24,0,1,1-2.47,0h0l0-6.57a1.2,1.2,0,0,1,2.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M391.22,692.31l.59,6.47v0a1.35,1.35,0,1,1-2.68.24h0l-.53-6.55a1.31,1.31,0,0,1,2.62-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M393.79,713.82l1.12,6.4v0a1.46,1.46,0,1,1-2.87.5v0L391,714.26a1.42,1.42,0,0,1,2.81-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M398.1,735.05l1.62,6.28v0a1.57,1.57,0,1,1-3,.78h0l-1.58-6.38a1.54,1.54,0,0,1,3-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M404.07,755.86l2.1,6.14,0,0a1.69,1.69,0,0,1-3.19,1.09v0l-2.07-6.24a1.65,1.65,0,0,1,3.13-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M411.62,776.15l2.57,6v0a1.79,1.79,0,0,1-3.29,1.41v0l-2.53-6.07a1.76,1.76,0,0,1,3.24-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M420.69,795.81l3,5.75,0,0a1.91,1.91,0,1,1-3.38,1.76v0l-3-5.86a1.87,1.87,0,0,1,3.33-1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M431.19,814.72l3.42,5.52,0,0a2,2,0,0,1-3.43,2.12v0l-3.41-5.62a2,2,0,0,1,3.38-2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M443.06,832.8l3.82,5.25,0,0a2.13,2.13,0,1,1-3.44,2.51v0l-3.82-5.36a2.1,2.1,0,0,1,3.4-2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M456.23,849.94l4.2,4.94,0,0a2.24,2.24,0,0,1-3.42,2.9v0l-4.22-5.06a2.21,2.21,0,0,1,3.38-2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M470.66,866l4.56,4.61,0,0a2.35,2.35,0,1,1-3.34,3.31h0l-4.59-4.74a2.32,2.32,0,0,1,3.31-3.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M486.27,881l4.9,4.23,0,0A2.46,2.46,0,1,1,488,889l0,0L483,884.59a2.43,2.43,0,0,1,3.2-3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M503,894.61l5.21,3.82.05,0a2.58,2.58,0,1,1-3.05,4.15h0l-5.27-4a2.55,2.55,0,0,1,3-4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M520.72,906.86l5.51,3.4,0,0a2.66,2.66,0,1,1-2.79,4.53h0l-5.6-3.5a2.64,2.64,0,0,1,2.78-4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M539.39,917.63l5.76,2.91.07,0a2.72,2.72,0,0,1-2.46,4.86h0l-5.87-3a2.7,2.7,0,0,1,2.45-4.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M558.89,926.74l6,2.4.07,0a2.78,2.78,0,0,1-2.07,5.17h0l-6.12-2.49a2.77,2.77,0,0,1,2.07-5.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M579.12,934.16l6.18,1.91.06,0a2.85,2.85,0,1,1-1.68,5.44h0l-6.3-2a2.83,2.83,0,0,1,1.68-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M599.88,940l6.31,1.42h.06a2.91,2.91,0,0,1-1.28,5.68h0l-6.43-1.49a2.89,2.89,0,0,1,1.28-5.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M621,944.14l6.4,1h.07a3,3,0,0,1-.87,5.88h0l-6.52-1a3,3,0,0,1,.88-5.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M642.42,946.76l6.46.49h.06a3,3,0,0,1-.46,6.06h0l-6.57-.54a3,3,0,0,1,.47-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M664,947.87l6.47.06h.07a3.1,3.1,0,0,1,0,6.19h0l-6.6-.09a3.08,3.08,0,0,1,.07-6.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M685.54,947.55l6.46-.36h.06a3.16,3.16,0,1,1,.35,6.31h0l-6.59.33a3.14,3.14,0,0,1-.34-6.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M707.05,945.87l6.44-.75h0a3.22,3.22,0,1,1,.76,6.4h0l-6.55.73a3.21,3.21,0,0,1-.74-6.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M728.44,942.91l6.38-1.12h0a3.29,3.29,0,1,1,1.15,6.47h0l-6.5,1.11a3.27,3.27,0,0,1-1.12-6.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M749.63,938.74l6.3-1.47H756a3.35,3.35,0,0,1,1.52,6.52h0l-6.41,1.47a3.33,3.33,0,0,1-1.5-6.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M770.56,933.44l6.24-1.81.05,0a3.41,3.41,0,1,1,1.9,6.56h0l-6.34,1.8a3.4,3.4,0,0,1-1.88-6.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M791.21,927.05l6.13-2.12,0,0a3.48,3.48,0,1,1,2.27,6.57h0l-6.24,2.12a3.46,3.46,0,0,1-2.24-6.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M811.51,919.64l6-2.41.05,0a3.54,3.54,0,1,1,2.63,6.57h0l-6.12,2.42a3.52,3.52,0,0,1-2.61-6.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M831.43,911.26l5.9-2.7,0,0a3.6,3.6,0,1,1,3,6.55h0l-6,2.71a3.59,3.59,0,0,1-3-6.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M850.93,902l5.77-3,0,0a3.66,3.66,0,1,1,3.36,6.51h0l-5.88,3a3.64,3.64,0,0,1-3.32-6.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M870,891.75l5.63-3.22,0,0a3.69,3.69,0,0,1,3.66,6.41h0l-5.71,3.24a3.68,3.68,0,1,1-3.64-6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M888.63,880.77l5.51-3.44,0,0a3.71,3.71,0,0,1,3.92,6.3h0l-5.59,3.47a3.7,3.7,0,0,1-3.91-6.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M906.85,869.08l5.38-3.63,0,0a3.73,3.73,0,0,1,4.17,6.19h0L911,875.28a3.72,3.72,0,0,1-4.16-6.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M924.65,856.75l5.26-3.82,0,0a3.75,3.75,0,1,1,4.4,6.08h0L929,862.84a3.75,3.75,0,0,1-4.39-6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M942,843.83l5.14-4,0,0a3.77,3.77,0,0,1,4.62,6h0l-5.2,4a3.77,3.77,0,0,1-4.6-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M959,830.4l5-4.13,0,0a3.8,3.8,0,0,1,4.82,5.87h0l-5.08,4.16a3.79,3.79,0,0,1-4.8-5.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M975.68,816.49l4.92-4.25,0,0a3.81,3.81,0,1,1,5,5.77h0l-5,4.28a3.8,3.8,0,1,1-5-5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M992,802.18l4.83-4.37v0a3.84,3.84,0,0,1,5.15,5.69h0l-4.88,4.39a3.83,3.83,0,1,1-5.12-5.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1008,787.5l4.73-4.46h0a3.86,3.86,0,0,1,5.29,5.61h0l-4.77,4.49a3.85,3.85,0,1,1-5.27-5.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1023.67,772.52l4.67-4.55h0a3.88,3.88,0,1,1,5.41,5.55h0l-4.7,4.56a3.87,3.87,0,1,1-5.4-5.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1039.14,757.27l4.61-4.63h0a3.9,3.9,0,1,1,5.52,5.5h0l-4.64,4.63a3.89,3.89,0,1,1-5.5-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1054.41,741.79l4.55-4.69h0a3.92,3.92,0,1,1,5.62,5.47h0l-4.57,4.69a3.91,3.91,0,1,1-5.61-5.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1069.5,726.13l4.51-4.73a3.94,3.94,0,0,1,5.72,5.42h0l-4.52,4.74a3.94,3.94,0,0,1-5.69-5.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1084.46,710.33l4.47-4.77a4,4,0,0,1,5.79,5.41h0l-4.49,4.77a4,4,0,0,1-5.76-5.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1099.33,694.42l4.44-4.79a4,4,0,0,1,5.84,5.42h0l-4.46,4.78a4,4,0,0,1-5.82-5.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1114.14,678.45l4.44-4.8a4,4,0,1,1,5.88,5.44h0l-4.45,4.79a4,4,0,0,1-5.86-5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1129,662.46l4.44-4.79a4,4,0,1,1,5.9,5.47h0l-4.45,4.78a4,4,0,1,1-5.88-5.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1143.78,646.49l4.46-4.78a4,4,0,0,1,5.91,5.52h0l-4.46,4.76a4,4,0,1,1-5.9-5.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1158.69,630.58l4.5-4.75a4.06,4.06,0,1,1,5.9,5.58h0l-4.49,4.74a4.06,4.06,0,0,1-5.9-5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1173.72,614.77l4.54-4.72a4.08,4.08,0,0,1,5.89,5.66h0l-4.53,4.69h0a4.08,4.08,0,0,1-5.87-5.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1188.9,599.09l4.6-4.67a4.1,4.1,0,1,1,5.85,5.76h0l-4.57,4.64h0a4.1,4.1,0,0,1-5.84-5.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1204.28,583.59l4.66-4.61a4.13,4.13,0,1,1,5.81,5.87h0l-4.64,4.57v0a4.13,4.13,0,0,1-5.8-5.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1219.9,568.31l4.74-4.53a4.14,4.14,0,1,1,5.73,6h0l0,0-4.71,4.5h0a4.14,4.14,0,0,1-5.72-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1235.8,553.31l4.84-4.44a4.13,4.13,0,0,1,5.59,6.09v0l-4.8,4.41v0a4.14,4.14,0,1,1-5.61-6.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1252,538.63l4.93-4.33a4.12,4.12,0,0,1,5.44,6.19h0l-4.88,4.31,0,0a4.12,4.12,0,1,1-5.45-6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1268.58,524.33l5-4.21a4.1,4.1,0,1,1,5.26,6.29l0,0-5,4.17,0,0a4.11,4.11,0,0,1-5.28-6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1285.49,510.45l5.15-4.07a4.09,4.09,0,0,1,5.07,6.41l0,0-5.09,4,0,0a4.09,4.09,0,1,1-5.09-6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1302.81,497l5.26-3.92a4.07,4.07,0,1,1,4.86,6.54l0,0-5.2,3.88,0,0a4.08,4.08,0,0,1-4.87-6.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1320.53,484.17l5.4-3.75a4.05,4.05,0,0,1,4.62,6.66l0,0-5.32,3.71,0,0a4.06,4.06,0,0,1-4.64-6.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1338.68,471.89l5.54-3.56a4,4,0,0,1,4.37,6.79l0,0-5.45,3.52,0,0a4,4,0,1,1-4.38-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1357.28,460.26l5.66-3.35a4,4,0,1,1,4.1,6.92l0,0-5.58,3.32,0,0a4,4,0,1,1-4.11-6.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1376.29,449.33l5.78-3.14a4,4,0,1,1,3.83,7l0,0-5.7,3.11,0,0a4,4,0,0,1-3.84-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1395.69,439.11l5.89-2.93a4,4,0,0,1,3.55,7.15l0,0-5.81,2.9,0,0a4,4,0,0,1-3.57-7.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1415.44,429.6l6-2.71a4,4,0,1,1,3.28,7.24l0,0-5.91,2.68,0,0a4,4,0,0,1-3.3-7.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1435.52,420.81l6.08-2.5a4,4,0,0,1,3,7.33h0l-6,2.48h0a4,4,0,0,1-3-7.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1455.9,412.74l6.17-2.28a3.94,3.94,0,1,1,2.73,7.4h0l-6.09,2.26,0,0a4,4,0,0,1-2.75-7.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1476.55,405.4l6.25-2.06a3.93,3.93,0,1,1,2.46,7.46h0l-6.17,2,0,0a3.93,3.93,0,0,1-2.47-7.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1497.46,398.79l6.32-1.84a3.91,3.91,0,0,1,2.18,7.52h0l-6.24,1.82h0a3.92,3.92,0,1,1-2.2-7.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1518.58,392.93l6.38-1.62a3.9,3.9,0,0,1,1.91,7.56h0l-6.3,1.61h0a3.9,3.9,0,1,1-1.92-7.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1539.9,387.81l6.43-1.4A3.88,3.88,0,0,1,1548,394h0l-6.35,1.38h0a3.88,3.88,0,1,1-1.65-7.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1561.39,383.44l6.47-1.17a3.87,3.87,0,1,1,1.37,7.61h0L1562.8,391h0a3.87,3.87,0,1,1-1.38-7.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1583,379.83l6.51-.94a3.85,3.85,0,1,1,1.09,7.62h0l-6.43.94h0a3.85,3.85,0,1,1-1.11-7.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1604.75,377l6.53-.71a3.84,3.84,0,0,1,.82,7.63h0l-6.46.7h0a3.84,3.84,0,1,1-.83-7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1626.57,374.9l6.56-.47a3.81,3.81,0,1,1,.54,7.61h0l-6.48.48h0a3.82,3.82,0,0,1-.56-7.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1648.45,373.6l6.57-.24a3.8,3.8,0,0,1,.27,7.6h0l-6.49.24h0a3.8,3.8,0,1,1-.29-7.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1670.36,373.08h6.57a3.79,3.79,0,0,1,0,7.57h0l-6.49,0h0a3.79,3.79,0,0,1,0-7.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1692.27,373.34l6.57.24a3.77,3.77,0,0,1-.27,7.53h0l-6.49-.22h0a3.78,3.78,0,0,1,.26-7.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1714.16,374.4l6.56.48a3.75,3.75,0,0,1-.54,7.48h0l-6.47-.46h0a3.76,3.76,0,1,1,.53-7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1736,376.26l6.54.71a3.74,3.74,0,0,1-.82,7.44h0l-6.46-.69h0a3.74,3.74,0,1,1,.8-7.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1757.76,378.92l6.5,1a3.72,3.72,0,0,1-1.08,7.36h0l-6.42-.94h0a3.73,3.73,0,0,1,1.07-7.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1779.4,382.42l6.47,1.22a3.7,3.7,0,1,1-1.37,7.28h0l-6.37-1.19h0a3.71,3.71,0,0,1,1.37-7.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1800.9,386.81l6.41,1.51a3.69,3.69,0,1,1-1.69,7.18h0l-6.31-1.47h0a3.7,3.7,0,0,1,1.67-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1822.19,392.17l6.33,1.81a3.67,3.67,0,1,1-2,7.06h0l-6.24-1.76,0,0a3.68,3.68,0,0,1,2-7.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1843.2,398.57l6.24,2.13a3.63,3.63,0,1,1-2.35,6.87h0l-6.14-2.07-.05,0a3.64,3.64,0,0,1,2.32-6.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1863.86,406.06l6.11,2.47a3.58,3.58,0,0,1-2.68,6.64l0,0-6-2.39-.06,0a3.6,3.6,0,0,1,2.66-6.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1884.08,414.7l6,2.83a3.54,3.54,0,0,1-3,6.39l0,0-5.85-2.75-.06,0a3.55,3.55,0,1,1,3-6.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1903.74,424.58l5.77,3.21a3.48,3.48,0,1,1-3.38,6.09l-.05,0-5.67-3.11-.06,0a3.5,3.5,0,1,1,3.38-6.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1922.72,435.74l5.54,3.61a3.44,3.44,0,0,1-3.76,5.76l0,0-5.42-3.51-.07,0a3.45,3.45,0,0,1,3.75-5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1940.86,448.26l5.25,4a3.39,3.39,0,1,1-4.12,5.38l-.06,0-5.14-3.91-.06-.05a3.4,3.4,0,1,1,4.12-5.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1958,462.16l4.9,4.45a3.34,3.34,0,1,1-4.48,4.95l-.06-.05-4.8-4.3-.06-.06a3.36,3.36,0,0,1,4.48-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1973.88,477.46l4.51,4.85a3.29,3.29,0,0,1-4.83,4.48l0-.05L1969.1,482,1969,482a3.31,3.31,0,1,1,4.83-4.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1988.39,494.1l4,5.26a3.25,3.25,0,1,1-5.15,3.95l-.06-.06-3.94-5.09-.06-.08a3.26,3.26,0,0,1,5.16-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2001.22,512.11l3.48,5.63a3.2,3.2,0,0,1-5.44,3.36l0-.07-3.4-5.45,0-.08a3.21,3.21,0,1,1,5.45-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2012.17,531.28l2.91,6a3.15,3.15,0,0,1-5.65,2.77l0-.07-2.86-5.77,0-.08a3.16,3.16,0,0,1,5.67-2.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2021.22,551.41l2.34,6.2a3.1,3.1,0,0,1-5.8,2.19l0-.07-2.3-6,0-.08a3.11,3.11,0,1,1,5.81-2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2028.36,572.28l1.77,6.37a3.06,3.06,0,0,1-5.89,1.63v-.06l-1.76-6.2,0-.08a3.07,3.07,0,1,1,5.91-1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2033.6,593.69l1.2,6.5a3,3,0,0,1-5.91,1.1v-.07l-1.2-6.34,0-.08a3,3,0,0,1,5.94-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2037,615.47l.64,6.58a3,3,0,1,1-5.88.57v-.06l-.66-6.43v-.07a3,3,0,1,1,5.91-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2038.45,637.44l.09,6.61a2.91,2.91,0,1,1-5.82.08v-.06l-.11-6.46v-.08a2.92,2.92,0,0,1,5.84-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2038.1,659.46l-.47,6.59a2.86,2.86,0,1,1-5.7-.4v-.06l.43-6.45v-.07a2.88,2.88,0,0,1,5.74.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2035.9,681.37l-1,6.53a2.81,2.81,0,0,1-5.56-.87V687l1-6.39v-.07a2.83,2.83,0,0,1,5.6.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2031.86,703l-1.57,6.42a2.76,2.76,0,1,1-5.37-1.32l0-.06,1.51-6.28v-.07a2.78,2.78,0,0,1,5.41,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2026,724.23l-2.13,6.26a2.71,2.71,0,0,1-5.14-1.75l0-.06,2-6.13,0-.07a2.73,2.73,0,1,1,5.18,1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2018.24,744.84l-2.68,6a2.67,2.67,0,1,1-4.87-2.17l0-.05,2.59-5.91,0-.07a2.69,2.69,0,1,1,4.92,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2008.66,764.66l-3.24,5.76a2.62,2.62,0,0,1-4.57-2.56l0-.06,3.14-5.65,0-.06a2.63,2.63,0,0,1,4.6,2.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1997.21,783.48l-3.79,5.41a2.54,2.54,0,0,1-4.17-2.89l0-.06,3.66-5.32,0-.06a2.56,2.56,0,1,1,4.22,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1984,801.07l-4.31,5a2.45,2.45,0,0,1-3.73-3.19l0-.06,4.18-4.92,0-.06a2.48,2.48,0,0,1,3.78,3.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1969,817.22l-4.81,4.55a2.37,2.37,0,0,1-3.26-3.43l0-.05,4.67-4.48.06,0a2.39,2.39,0,0,1,3.31,3.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1952.46,831.77l-5.23,4a2.28,2.28,0,0,1-2.8-3.6l0,0,5.09-4,.06,0a2.3,2.3,0,0,1,2.84,3.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1934.58,844.59,1929,848.1a2.19,2.19,0,0,1-2.34-3.71l0,0,5.46-3.48,0,0a2.22,2.22,0,1,1,2.39,3.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1915.59,855.65l-5.89,3a2.11,2.11,0,0,1-1.91-3.76l0,0,5.76-3,.05,0a2.14,2.14,0,1,1,1.95,3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1895.67,864.91l-6.12,2.43a2,2,0,0,1-1.51-3.76l.06,0,6-2.43.05,0a2.05,2.05,0,0,1,1.54,3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1875,872.37l-6.31,1.88a1.94,1.94,0,0,1-1.13-3.71h.05l6.21-1.91h0a2,2,0,1,1,1.16,3.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1853.83,878l-6.45,1.34a1.85,1.85,0,0,1-.77-3.62h.05l6.34-1.37h0a1.88,1.88,0,0,1,.79,3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1832.23,881.85l-6.53.79a1.77,1.77,0,0,1-.44-3.51h0l6.44-.84h0a1.79,1.79,0,1,1,.46,3.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1810.4,883.85l-6.57.25a1.68,1.68,0,0,1-.14-3.36h0l6.48-.3h0a1.71,1.71,0,0,1,.15,3.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1788.48,884l-6.57-.31a1.6,1.6,0,0,1,.14-3.19h0l6.49.26h0a1.62,1.62,0,1,1-.13,3.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1766.63,882.33l-6.52-.87a1.51,1.51,0,0,1,.39-3h0l6.45.81h0a1.53,1.53,0,1,1-.39,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1745,878.75l-6.41-1.44a1.43,1.43,0,0,1,.61-2.79h0l6.35,1.38h0a1.45,1.45,0,1,1-.62,2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1723.79,873.26l-6.24-2a1.34,1.34,0,0,1-.86-1.69,1.33,1.33,0,0,1,1.67-.86h0l6.19,1.95h0a1.36,1.36,0,1,1-.82,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1703.2,865.84l-6-2.61a1.25,1.25,0,1,1,1-2.3h0l6,2.53,0,0a1.28,1.28,0,1,1-1,2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1683.4,856.48l-5.74-3.19a1.17,1.17,0,0,1,1.12-2l0,0,5.71,3.1,0,0a1.19,1.19,0,0,1-1.14,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1664.65,845.19l-4.23-2.92a1.09,1.09,0,0,1,1.23-1.8l0,0,4.21,2.86h0a1.11,1.11,0,1,1-1.25,1.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1525.09,1554.62a5.89,5.89,0,0,0,6-4.49l94-497.46c.56-2.94-1.66-5.72-5-6.22s-6.41,1.49-7,4.43l-94,497.45c-.55,2.94,1.66,5.72,5,6.22A7,7,0,0,0,1525.09,1554.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1842.12,1554.63a7,7,0,0,0,1.2-.11c3.27-.59,5.39-3.44,4.73-6.36l-110.78-491c-.66-2.92-3.84-4.83-7.12-4.22s-5.39,3.43-4.73,6.35l110.78,491A5.92,5.92,0,0,0,1842.12,1554.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1596.79,1175.61h160.59c3.34,0,6-2.42,6-5.4s-2.7-5.4-6-5.4H1596.79c-3.33,0-6,2.42-6,5.4S1593.46,1175.61,1596.79,1175.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1599.7,1175.61h154.77a5.42,5.42,0,1,0,0-10.8H1599.7a5.42,5.42,0,1,0,0,10.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1596.79,1265.55h160.59c3.34,0,6-2.41,6-5.39s-2.7-5.4-6-5.4H1596.79c-3.33,0-6,2.42-6,5.4S1593.46,1265.55,1596.79,1265.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M1582.21,1265.55H1776.9c3.34,0,6-2.41,6-5.39s-2.7-5.4-6-5.4H1582.21c-3.34,0-6,2.42-6,5.4S1578.87,1265.55,1582.21,1265.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1596.79,1355.5h160.59c3.34,0,6-2.41,6-5.4s-2.7-5.39-6-5.39H1596.79c-3.33,0-6,2.41-6,5.39S1593.46,1355.5,1596.79,1355.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M1563.61,1355.5h233.05c3.34,0,6-2.41,6-5.4s-2.7-5.39-6-5.39H1563.61c-3.33,0-6,2.41-6,5.39S1560.28,1355.5,1563.61,1355.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M1596.79,1445.45h218.6c3.34,0,6-2.42,6-5.4s-2.71-5.4-6-5.4h-218.6c-3.33,0-6,2.42-6,5.4S1593.46,1445.45,1596.79,1445.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M1548.57,1445.45h266.82c3.34,0,6-2.42,6-5.4s-2.71-5.4-6-5.4H1548.57c-3.33,0-6,2.42-6,5.4S1545.24,1445.45,1548.57,1445.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M1741.27,1233.52s3.91,6.18,4.9,23.47a2.82,2.82,0,0,1-2.8,3h-30.65a1.81,1.81,0,0,1-1.72-2.38c1.8-5.32,7.23-18.28,19.35-25.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M1742.6,1221.8l-1.74,14.53a2.74,2.74,0,0,1-2.38,2.41,24.36,24.36,0,0,1-6.48-.06,4.5,4.5,0,0,1-3.71-4.46v-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1665.43,1231.92a42.71,42.71,0,0,1,5.74,21.63,5.42,5.42,0,0,1-5.45,5.3h-47.6a2.28,2.28,0,0,1-1.31-4.15c9-6.32,26.71-18.14,39.52-22.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M1670.33,1216.22l-3.7,18a3.69,3.69,0,0,1-4.38,2.91,13.33,13.33,0,0,1-4.18-1.75,4.24,4.24,0,0,1-1.9-4.34l3.83-21.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1735.81,966.6s12.85,11.34,15.27,25-6.85,235.3-6.85,235.3-12.86,2.14-19.49-1.88c0,0-7.86-143.86-13.83-177.1,0,0-31.34,149-40,175.94,0,0-12.39,1.51-16.38-.85,0,0,8.21-193.16,18.52-227.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M1711.28,1043.38a1.31,1.31,0,0,1-.39-.05,1.56,1.56,0,0,1-1.12-1.89l5.47-21a1.51,1.51,0,0,1,.66-.92l11.8-7.57a1.56,1.56,0,1,1,1.68,2.62l-11.29,7.24-5.3,20.36A1.57,1.57,0,0,1,1711.28,1043.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1603,841c53.7-8.12,68.57,2.1,68.57,2.1l-23.19,42.72s-53.14,2.53-93.13-24.22a93.08,93.08,0,0,0,13.7-23.75A71.73,71.73,0,0,0,1603,841Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M1513.11,767.46a1.66,1.66,0,0,1,3.11-.84l7.88,14.24a15.42,15.42,0,0,1,1.84,9l-1.85,8.72a14.8,14.8,0,0,0,3.81,11.55c6.86,7.49,21.32,21,41.06,27.73a93.08,93.08,0,0,1-13.7,23.75c-14.68-9.81-27.59-23.56-35.45-42.83a7.25,7.25,0,0,1-5.58-6.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M1591.11,862.33c19.05-20.53,55.35-29.81,76.36-33.62A19.28,19.28,0,0,1,1689,840.93c9.46,25.42,35.18,91.56,40.16,102.92,4.09,9.33,8.36,18.44,11.07,24.13a6.83,6.83,0,0,1-3.18,9.11c-17.68,8.52-49.5,18.16-62.39,21.92a4.42,4.42,0,0,1-5.66-4.25,13.84,13.84,0,0,0-2-7.12l-48.84-81.39c-30.44,33.75-57.1,36.84-77.58,29.45a154.23,154.23,0,0,0,6.77-32C1577.64,898.53,1591.11,862.33,1591.11,862.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M1495.1,895.4l5.88-9.51c17.67,12.14,34.31,19.89,46.4,17.82a154.23,154.23,0,0,1-6.77,32C1513.62,926,1495.1,895.4,1495.1,895.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M1502.82,881.93s-.2-.26-.56-.67c-1.75-2-7.2-7.6-10.67-3.46-4.18,5-16.86,25.72-16.86,25.72s-18.77,14.25-19.44,19L1482,912.39a13.83,13.83,0,0,0,6-4.43l13.4-17.28A9.27,9.27,0,0,0,1502.82,881.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M1638.57,791l16.23,39.61s-18.65,12.91-33.66,11.68l-8.1-35.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1611.15,764c-.37.53-11.74,41.61-11.74,41.61l23.59,6,16.56-37.33S1617.37,755.19,1611.15,764Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M1630.68,779.94l-7.18,20.34a3.09,3.09,0,0,1-.38.72c-1,1.39-4.67,5.9-9.06,1.84-4-3.7-7.68-7-11.08-7.61a3,3,0,0,0-3.43,2.17,130.82,130.82,0,0,0-4,19.81,3,3,0,0,0,2.45,3.24c4.6.88,14.37,2.45,22.53,1.88a3,3,0,0,0,2.54-1.75c2.25-4.91,9.13-19.82,11.69-23.67,2.41-3.62,8.3-3.52,10.77-3.3a3,3,0,0,0,2.22-.73c2.16-1.89,6.28-6.73.49-12.52a3,3,0,0,1,.07-4.35c2.49-2.33,5.14-6.48,1-11.62s-9.76-4.39-13.17-3.15a3,3,0,0,1-3.63-1.34,2.37,2.37,0,0,0-2.45-1.15,3,3,0,0,1-3.17-3c.06-3.35-1.14-7.58-7-9.39-10.3-3.21-16.73,6.75-17.37,14.18s10.74,10.27,17.43,9.77c5.08-.38,8.85,4.66,10.37,7.1A3,3,0,0,1,1630.68,779.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1632.11,804.29s1.66-12.9,7-13.53,10.58,3.77,5.25,11C1637.75,810.78,1632.11,804.29,1632.11,804.29Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmImg1);
export default __webpack_public_path__ + "static/media/crm_img_1.34710b80789fc0aceb0d18d09dce2241.svg";
export { ForwardRef as ReactComponent };